import { render, staticRenderFns } from "./dialogCompleteAss.vue?vue&type=template&id=2375da8c&scoped=true"
import script from "./dialogCompleteAss.vue?vue&type=script&lang=js"
export * from "./dialogCompleteAss.vue?vue&type=script&lang=js"
import style0 from "./dialogCompleteAss.vue?vue&type=style&index=0&id=2375da8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2375da8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog})
